'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);

var _components = require('../../components');
var _CellPhotoBlock = require('../OMComponents/OMPropertyCells/components/CellPhotoBlock/CellPhotoBlock');var _CellPhotoBlock2 = _interopRequireDefault(_CellPhotoBlock);

var _beautifyNumber = require('../../helpers/beautifyNumber');var _beautifyNumber2 = _interopRequireDefault(_beautifyNumber);
var _constants = require('../../constants');
var _services = require('../../services');

var _ProjectPropertyCell = require('./ProjectPropertyCell.scss');var styles = _interopRequireWildcard(_ProjectPropertyCell);
var _modifyImageLink = require('../../utils/modifyImageLink');var _modifyImageLink2 = _interopRequireDefault(_modifyImageLink);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Helpers
// Styles
var currencies = {
  ILS: '₪',
  USD: '$',
  EUR: '€' };var

ProjectPropertyCell = function (_Component) {_inherits(ProjectPropertyCell, _Component);function ProjectPropertyCell() {var _temp, _this, _ret;_classCallCheck(this, ProjectPropertyCell);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      loading: false,
      translateSummaryRequired: false,
      sourceLanguage: null,
      showOriginalSummary: false,
      translatedSummary: null }, _this.
















    handleToggleTranslate = function () {
      var requireTranslate =
      !_this.state.loading &&
      _this.state.translateSummaryRequired &&
      !_this.state.translatedSummary;


      if (requireTranslate) {
        _this.setState({ loading: true });
        _services.TranslationService.
        translate(_this.props.summary, _this.props.locale, _this.state.sourceLanguage).
        then(function (translatedSummary) {return _this.setState({ translatedSummary: translatedSummary, loading: false, showOriginalSummary: true });}).
        catch(function () {return _this.setState({ loading: false, translateSummaryRequired: false, showOriginalSummary: false });});
      } else {
        _this.setState(function (prevState) {return Object.assign({},
          prevState, {
            showOriginalSummary: !prevState.showOriginalSummary });});

      }
    }, _this.

    renderPrice = function () {var _this$props =
      _this.props,isMobile = _this$props.isMobile,price = _this$props.price,exactPrice = _this$props.exactPrice,translate = _this$props.translate,locale = _this$props.locale;
      var isDefaultLanguage = locale === _constants.language.default;
      var priceLocalizationKey = isMobile || !isDefaultLanguage ? 'from' : 'startingFrom';
      var separator = isMobile ? ' ' : ' - ';
      var nis = currencies[_this.props.currency] || currencies.ILS;
      var ltrSymbol = String.fromCharCode(8206);

      var formattedPrice = exactPrice ? '' +
      ltrSymbol + nis + ' ' + (0, _beautifyNumber2.default)(exactPrice) : '' +
      translate(priceLocalizationKey) + separator + nis + (0, _beautifyNumber2.default)(price);

      return (
        _react2.default.createElement('div', { className: styles.price },
          formattedPrice));


    }, _this.

    renderShowAllButton = function () {return (
        _react2.default.createElement('p', { className: styles.buttonShow },
          _this.props.translate('showAll')));}, _this.



    renderHideShowAllButton = function () {return (
        _react2.default.createElement('p', { className: styles.buttonShow },
          _this.props.translate('propertyDetails', 'hideDescription')));}, _this.



    renderPhotoBlock = function () {var _this$props2 =
      _this.props,image = _this$props2.image,isRtl = _this$props2.isRtl,images = _this$props2.images,isMobile = _this$props2.isMobile;
      var photo = image || (0, _get2.default)(_this.props, 'images[0].full', null);

      return !isMobile ?
      _react2.default.createElement(_CellPhotoBlock2.default, {
        className: 'projectPropertyCell',
        photo: photo,
        images: images,
        isRtl: isRtl,
        withoutFavorite: true,
        withoutCurrency: true,
        withoutPagination: true }) :


      _react2.default.createElement('div', { className: styles.photoWrapper },
        _react2.default.createElement('img', { src: photo, alt: '' }));


    }, _temp), _possibleConstructorReturn(_this, _ret);}ProjectPropertyCell.prototype.componentDidMount = function componentDidMount() {var _this2 = this;if (this.props.summary) {_services.TranslationService.suggestStringLanguage(this.props.summary, 0.7).then(function (detection) {if (detection) {_this2.setState({ translateSummaryRequired: detection.language !== _this2.props.locale, sourceLanguage: detection.language });}});}};ProjectPropertyCell.prototype.

  render = function render() {var _props =
    this.props,translate = _props.translate,summary = _props.summary;

    var summaryText = !this.state.showOriginalSummary ?
    summary :
    this.state.translatedSummary;

    return (
      _react2.default.createElement('div', { className: styles.projectPropertyCell, key: this.props.id },
        _react2.default.createElement('div', { className: styles.imageSection, onClick: this.props.openLightbox },
          this.renderPhotoBlock()),

        _react2.default.createElement('div', { className: styles.descriptionSection },
          _react2.default.createElement('div', { className: styles.topBlock },
            this.renderPrice(),
            _react2.default.createElement('div', { className: styles.propertyType },
              translate('propertyTypes', this.props.type))),


          _react2.default.createElement('div', { className: styles.summaryBlock },
            _react2.default.createElement('div', null,
              _react2.default.createElement('p', { className: styles.title }, translate('propertyDetails', 'name')),
              _react2.default.createElement('p', { className: styles.info, title: this.props.name }, this.props.name)),

            _react2.default.createElement('div', null,
              _react2.default.createElement('p', { className: styles.title }, translate('propertyDetails', 'roomsProperty')),
              _react2.default.createElement('p', { className: styles.info }, this.props.rooms)),

            _react2.default.createElement('div', null,
              _react2.default.createElement('p', { className: styles.title }, translate('propertyDetails', 'apartmentArea')),
              _react2.default.createElement('p', { className: styles.info }, this.props.area)),

            _react2.default.createElement('div', null,
              _react2.default.createElement('p', { className: styles.title }, translate('propertyDetails', 'descriptionProperty')),
              _react2.default.createElement('p', { className: styles.info },
                _react2.default.createElement(_components.ShowMore, {
                  customStyles: styles.showMore,
                  text: summaryText,
                  moreButtonText: this.renderShowAllButton(),
                  hideButtonText: this.renderHideShowAllButton(),
                  heightLimit: this.props.isMobile ? 100 : 60,
                  showHideButton: true,
                  withoutEllipses: true,
                  withTextEllipses: true,
                  translateButton: this.state.translateSummaryRequired &&
                  _react2.default.createElement('button', {
                      type: 'button',
                      className: styles.showOriginalDescription,
                      onClick: this.handleToggleTranslate },

                    _react2.default.createElement('span', null,
                      this.props.translate('propertyDetails', 'multilingualDescription', this.state.showOriginalSummary ?
                      'showOriginalDescription' :
                      'returnTranslation')),



                    _react2.default.createElement('span', { className: styles.sub }, 'Powered by Google')) })))))));










  };return ProjectPropertyCell;}(_react.Component);


ProjectPropertyCell.propTypes = {
  isMobile: _propTypes2.default.bool,
  isRtl: _propTypes2.default.bool,
  locale: _propTypes2.default.string,
  image: _propTypes2.default.string,
  id: _propTypes2.default.string,
  images: _propTypes2.default.array,
  price: _propTypes2.default.number,
  exactPrice: _propTypes2.default.number,
  area: _propTypes2.default.number,
  rooms: _propTypes2.default.number,
  name: _propTypes2.default.string,
  summary: _propTypes2.default.string,
  type: _propTypes2.default.string,
  currency: _propTypes2.default.string,
  translate: _propTypes2.default.func,
  openLightbox: _propTypes2.default.func };exports.default =


ProjectPropertyCell;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectPropertyCell/ProjectPropertyCell.js
// module id = 2779
// module chunks = 0